module.exports = __webpack_public_path__ + "static/img/button.221fa39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/kocom/button.png
// module id = 972O
// module chunks = 1